import { render, staticRenderFns } from "./FontBold.vue?vue&type=template&id=422c3c0b"
import script from "./FontBold.vue?vue&type=script&lang=js"
export * from "./FontBold.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports